import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormHelperText
} from '@material-ui/core'
import { get } from 'lodash'
import React from 'react'

import { batchTypesMap } from 'app/pages/Class/Inventory/constants'
import { formatAmountIndian } from 'app/utils'

import * as Styles from './styles'

import AdditionalDiscount from '../../../AdditionalDiscount'
import { fetchProgramStartDates } from '../../../helpers'
import PaymentCycle from '../../../PaymentCycle'
import { SchedulesDate } from '../../../SchedulesDate'

const CourseDetail = ({
  selectedProgram,
  batchInfo,
  onBatchInfoChange,
  courseFormDisabled,
  startDateDisabled = courseFormDisabled,
  batchDetails
}) => {
  if (!selectedProgram) return null
  const { icon, name, image } = selectedProgram
  const currentBatchInfo = get(batchInfo, batchDetails?.uuid, {})

  const feeFound = currentBatchInfo?.feeFound ?? false
  const annualFee = currentBatchInfo?.annualFee

  return (
    <Styles.FormContainer>
      <Styles.Container>
        <Styles.TopContainer>
          <Styles.LeftContainer>
            {icon && (
              <Styles.ImageContainer>
                <Styles.Image src={image} />
              </Styles.ImageContainer>
            )}
            <Styles.DescriptionContainer>
              {name && <Styles.Title>{name}</Styles.Title>}
            </Styles.DescriptionContainer>
          </Styles.LeftContainer>
          <Styles.RightContainer>
            {feeFound ? (
              <Styles.PriceContainer>
                <Styles.PriceText>
                  {formatAmountIndian(annualFee)}
                  <Styles.PriceSmallText>/yr</Styles.PriceSmallText>
                </Styles.PriceText>
              </Styles.PriceContainer>
            ) : null}
          </Styles.RightContainer>
        </Styles.TopContainer>
        <Divider style={{ margin: '1em 0' }} />
        <Styles.BottomContainer>
          <Styles.OtherDetailsContainer>
            <SchedulesDate
              batchId={batchDetails?.uuid}
              value={get(currentBatchInfo, 'startDate')}
              handleOnChange={onBatchInfoChange}
              propertyChange={'startDate'}
              placeholder={'Start Date'}
              batchInfo={currentBatchInfo}
              disabled={startDateDisabled}
              scheduleFunction={fetchProgramStartDates}
            />
            <PaymentCycle
              currentBatchInfo={currentBatchInfo}
              onBatchInfoChange={onBatchInfoChange}
              disabled={courseFormDisabled}
              batchDetails={batchDetails}
            />
            {/* Feature 3 — daycare GST toggle. Hidden for CARE
                programmes (out of scope per Decision #5). The flag flows
                through `batchFormInfo.isDaycareBilling` into the cart
                payload as `is_daycare_billing` on each item. */}
            {batchDetails?.type === batchTypesMap.school ? (
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(
                        get(currentBatchInfo, 'isDaycareBilling', false)
                      )}
                      onChange={(e) =>
                        onBatchInfoChange(
                          batchDetails?.uuid,
                          'isDaycareBilling',
                          e.target.checked
                        )
                      }
                      disabled={courseFormDisabled}
                      color="primary"
                      size="small"
                    />
                  }
                  label="Generate as daycare GST invoice"
                />
                <FormHelperText>
                  Applies 18% GST on the full programme fee and AIM.
                  Used when the parent's employer requires a
                  daycare-format invoice.
                </FormHelperText>
              </div>
            ) : null}
            {/* Feature 5 — AIM-only seat block. Hidden for CARE programmes
                (Decision #5 — preschool-only). When checked, only AIM is
                charged at submit; the programme line still holds the
                batch + variant + centre lock on the resulting admission
                record, but its cost contribution is zeroed at cart-time. */}
            {batchDetails?.type === batchTypesMap.school ? (
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(
                        get(currentBatchInfo, 'isSeatBlock', false)
                      )}
                      onChange={(e) =>
                        onBatchInfoChange(
                          batchDetails?.uuid,
                          'isSeatBlock',
                          e.target.checked
                        )
                      }
                      disabled={courseFormDisabled}
                      color="primary"
                      size="small"
                    />
                  }
                  label="Seat block only (charge AIM, defer term fee)"
                />
                <FormHelperText>
                  The student&apos;s batch and programme variant will be
                  reserved. Only the AIM (₹18,000) is charged now.
                  Term fee gets invoiced when the parent is ready to
                  convert.
                </FormHelperText>
              </div>
            ) : null}
            {batchDetails?.type === batchTypesMap.school ? (
              <AdditionalDiscount
                currentBatchInfo={currentBatchInfo}
                onBatchInfoChange={onBatchInfoChange}
                disabled={courseFormDisabled}
                batchDetails={batchDetails}
              />
            ) : null}
          </Styles.OtherDetailsContainer>
        </Styles.BottomContainer>
      </Styles.Container>
    </Styles.FormContainer>
  )
}

export { CourseDetail }
